import React, { useState } from 'react'
import { Document, getProjectDocuments, deleteDocument } from 'utils/DocumentsUtils';
import { useAppContext } from 'hooks/useAppContext';
import Grid from 'components/Custom/Grid'
import SkeletonGrid from 'components/Shared/SkeletonGrid';
import GridDocuments from './Artifacts/GridDocuments';

const DocumentsGrid = ({callback}) => {
  const columns = Document.columns
  const { selectedProject } = useAppContext(); //Getting the App Context
  const title = "Documents"
  const getFormPath = () => import('components/Documents/DocumentForm')
  const [updateDate, setUpdateDate] = useState(new Date());


  return (
    <div key={updateDate}>
            {
                selectedProject ?
                    <GridDocuments callback={callback} />
                     :
                    <SkeletonGrid title={title} />
            }
        </div>
     )
}

export default DocumentsGrid
